(function () {
    'use strict';

    if (window.BcThemedMedia) return;

    function isDark() {
        return document.documentElement.getAttribute('data-theme') === 'dark';
    }

    function onThemeChange(callback) {
        let dark = isDark();
        const observer = new MutationObserver(function () {
            const next = isDark();
            if (next === dark) return;
            dark = next;
            callback(dark);
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });
        return observer;
    }

    function source(src, type) {
        const el = document.createElement('source');
        el.src = src;
        el.type = type;
        return el;
    }

    function play(media) {
        const started = media.play();
        if (started && typeof started.catch === 'function') started.catch(function () {});
    }

    window.BcThemedMedia = {
        isDark: isDark,
        onThemeChange: onThemeChange,
        source: source,
        play: play,
    };
})();
